/**
 * Notifications API Service
 *
 * Popup-/In-App-Benachrichtigungen für neue/verschobene/erschienene Bände.
 *
 * Endpoints:
 * GET   /notifications?cursor=0&limit=50  - Benachrichtigungen laden (Offset-Cursor)
 * PATCH /notifications/{id}/read          - Einzelne als gelesen markieren
 * PATCH /notifications/read-all           - Alle als gelesen markieren
 */

import { get, patch } from '../client';

/**
 * Benachrichtigungen laden
 * @param {object} options - { cursor?: number, limit?: number }
 * @returns {Promise<{success: boolean, data?: {items: NotificationItem[], next_cursor: number|null}, error?: object}>}
 */
export const getNotifications = async (options = {}) => {
  const params = {};
  if (options.cursor !== undefined && options.cursor !== null) params.cursor = options.cursor;
  params.limit = options.limit ?? 50;
  return get('/notifications', params);
};

/**
 * Einzelne Benachrichtigung als gelesen markieren
 * @param {number} id - Notification ID
 * @returns {Promise<{success: boolean, data?: {message: string}, error?: object}>}
 */
export const markRead = async (id) => {
  return patch(`/notifications/${id}/read`);
};

/**
 * Alle Benachrichtigungen als gelesen markieren
 * @returns {Promise<{success: boolean, data?: {message: string}, error?: object}>}
 */
export const markAllRead = async () => {
  return patch('/notifications/read-all');
};

// ============================================================================
// TYPES (JSDoc)
// ============================================================================

/**
 * @typedef {object} NotificationItem
 * @property {number} id
 * @property {'NEW_BAND'|'DATE_CHANGED'|'RELEASED'} type
 * @property {string} title
 * @property {string} body
 * @property {boolean} read
 * @property {number} manga_id
 * @property {string} manga_title
 * @property {number} band_id
 * @property {number} band_number
 * @property {string} created_at
 */
